export const FORM_STEPS = [
  { number: 1, title: "Personal Info" },
  { number: 2, title: "Financial Info" },
  { number: 3, title: "Documents" },
  { number: 4, title: "Review" }
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  { value: "employed", label: "Employed" },
  { value: "self-employed", label: "Self-Employed" },
  { value: "unemployed", label: "Unemployed" },
  { value: "retired", label: "Retired" },
  { value: "student", label: "Student" }
];

export const CREDIT_SCORE_OPTIONS = [
  { value: "excellent", label: "Excellent (750+)" },
  { value: "good", label: "Good (700-749)" },
  { value: "fair", label: "Fair (650-699)" },
  { value: "poor", label: "Poor (600-649)" },
  { value: "bad", label: "Bad (<600)" }
];

export const COUNTRY_OPTIONS = [
  { value: "USA", label: "United States" },
  { value: "Canada", label: "Canada" }
];

export const USA_STATES = [
  { value: "AL", label: "Alabama" }, { value: "AK", label: "Alaska" }, { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" }, { value: "CA", label: "California" }, { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" }, { value: "DE", label: "Delaware" }, { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" }, { value: "HI", label: "Hawaii" }, { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" }, { value: "IN", label: "Indiana" }, { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" }, { value: "KY", label: "Kentucky" }, { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" }, { value: "MD", label: "Maryland" }, { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" }, { value: "MN", label: "Minnesota" }, { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" }, { value: "MT", label: "Montana" }, { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" }, { value: "NH", label: "New Hampshire" }, { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" }, { value: "NY", label: "New York" }, { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" }, { value: "OH", label: "Ohio" }, { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" }, { value: "PA", label: "Pennsylvania" }, { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" }, { value: "SD", label: "South Dakota" }, { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" }, { value: "UT", label: "Utah" }, { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" }, { value: "WA", label: "Washington" }, { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" }, { value: "WY", label: "Wyoming" }
];

export const CANADA_PROVINCES = [
  { value: "AB", label: "Alberta" }, { value: "BC", label: "British Columbia" }, { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" }, { value: "NL", label: "Newfoundland and Labrador" }, { value: "NS", label: "Nova Scotia" },
  { value: "NT", label: "Northwest Territories" }, { value: "NU", label: "Nunavut" }, { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" }, { value: "QC", label: "Quebec" }, { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon" }
];

/** @deprecated Use USA_STATES or CANADA_PROVINCES based on country selection */
export const STATE_OPTIONS = USA_STATES;

export const AUTHORIZATION_TEXT = {
  terms: "I confirm that I have read, understood, and agree to Sayaara's Terms & Conditions.",
  softCredit: "I authorize Sayaara to perform a soft credit check and background verification to pre-approve my car financing eligibility. This soft inquiry will not impact my credit score and will be used solely for evaluating eligibility for Sayaara's financing programs.",
  hardCredit: "I authorize Sayaara and its partnering dealerships to conduct a hard credit inquiry and comprehensive background check to finalize and approve my car financing application. I understand this hard inquiry may temporarily affect my credit score. I acknowledge this is necessary to complete the financing process.",
  dataConsent: "I consent to Sayaara securely collecting, storing, processing, and managing my personal and financial information and any uploaded documents. I understand and agree that my data will be used solely for the purposes of processing my car financing application, providing related customer support, ensuring Shariah-compliance, and complying with legal requirements, in accordance with Sayaara's Privacy Policy."
};

export const DOCUMENT_TYPES = [
  {
    label: "Photo ID (Driver's License or Passport)",
    accept: ".pdf,.jpg,.jpeg,.png",
    required: true
  },
  {
    label: "Proof of Income (Pay Stubs, Tax Returns)",
    accept: ".pdf,.jpg,.jpeg,.png",
    required: true
  },
  {
    label: "Bank Statements (Last 3 months)",
    accept: ".pdf,.jpg,.jpeg,.png",
    required: true
  },
  {
    label: "Proof of Residence (Utility Bill)",
    accept: ".pdf,.jpg,.jpeg,.png",
    required: false
  },
  {
    label: "References (Contact Information)",
    accept: ".pdf,.jpg,.jpeg,.png",
    required: false
  }
];